<template lang="html">
    <div>
        <div class="vx-card nexteventheader_div">
        <div class="vx-card__header">
        <div class="vx-card__title">
        <p class="h6">Design Configurations : {{configTitle}}</p>

        </div>
        <vs-button style="float:right;" @click="$router.push({ path: '/admin/designsettings' })">{{$t('Back')}}</vs-button>
        </div>
            <div style="padding: 21px;">
                <!-- <div style="margin-bottom: 10px;">
                    <label>Title:</label>
                    <vs-input class="w-full" v-model="configTitle" disabled />
                </div>
                <div style="margin-bottom: 10px;">
                    <label>Slug:</label>
                    <vs-input class="w-full" v-model="configSlug" disabled />
                </div> -->
                <div style="margin-bottom: 20px;">
                    <label v-if="configSlug != 'background_mp3' ? true : false">{{$t('design_settings.upload_logo_w_ext')}} - .jpg .jpeg .png .gif </label>
                    <label v-if="configSlug == 'background_mp3' ? true : false">{{$t('design_settings.upload_mp3_w_ext')}} - .mp3 </label>
                    <br>
                    <label>{{configDescription}} </label>
                </div>
                <div style="margin-bottom: 10px;">
                    <label>{{$t(configSlug == 'background_mp3' ? 'design_settings.upload_mp3' : 'design_settings.upload_logo')}}:</label>
                    <br />
                    <label>
                    <input style="margin-top: 10px;" type="file" id="file" ref="file" name="file" v-on:change="handleFileUpload()" :accept="configSlug == 'background_mp3' ? 'mp3/*' : 'image/*'"/>
                    </label>
                    <!-- <div v-if="imageError" class="imageError" style="margin-top: 10px;">
                        {{imageError}}
                    </div> -->
                </div>
            </div>
            <div>
                <vs-button @click="updateConfig()" class="updateConfigBtn" style="margin-left: 15px;margin-bottom:10px;">{{$t('Save')}}</vs-button>
            </div>
            </div>
        </div>
</template>

<script>
import $ from "jquery";
export default {
    data() {
      return {
            config_id: '',
            configTitle: '',
            configSlug: '',
            configDescription: '',
            configWidth: '',
            configHeight: '',
            file: '',
            image:{
                size:'',
                height:'',
                width:''
            },
            imageError:''
      }
    },
    mounted() {
        this.getConfigData()
    },
    created() {
        this.config_id = this.$route.params.id;
    },
    methods: {
        getConfigData(){
            this.$vs.loading();
            this.$store
            .dispatch("GetDesignConfig")
            .then(response => {
                this.smsEmailConfig = response.data.data;
                this.smsEmailConfig.forEach((config) => {
                    if(config.id == this.config_id){
                        this.configTitle = config.title
                        this.configSlug = config.slug;
                        this.configDescription = config.description;
                        this.configWidth = config.width;
                        this.configHeight = config.height;
                    }
                });
                this.$vs.loading.close();
            })
            .catch(error => {
                this.$vs.loading.close();
                // Error response
                this.$vs.notify({
                    title: "Failed to load data",
                    text: error,
                    color: "danger",
                    position: "top-center"
                });
                return false;
            });
        },
        updateConfig(){
            this.$vs.loading();
            let formData = new FormData();
            formData.append('id', this.config_id);
            formData.append('slug', this.configSlug);
            formData.append('image', this.file);

            this.$store
                .dispatch("UpdateDesignConfig", formData)
                .then(response => {
                    this.getConfigData();
                    console.log("response", response)
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Configuration updated successfully!",
                        color: "success",
                        position: "top-center"
                    });
                    this.$router.push({ path: '/admin/designsettings/'})
                })
                .catch(error => {
                    this.$vs.loading.close();
                    // Error response
                    this.$vs.notify({
                        title: "Could not update Configuration.",
                        text: error,
                        color: "danger",
                        position: "top-center"
                    });
                    return false;
                });
        },
        handleFileUpload(){
            let filevalue = this.$refs.file.files[0];
            var filePath = filevalue.name;
            var allowedExtensions = this.configSlug != 'background_mp3' ? /(\.jpg|\.jpeg|\.png|\.gif)$/i : /(\.mp3)$/i;
            if(!allowedExtensions.exec(filePath)){
                this.$vs.notify({
                    title: "File upload",
                    text: this.configSlug != 'background_mp3' ? "Please upload file having extensions .jpeg .jpg .png .gif only." : "Please upload file having extensions .mp3 only.",
                    color: "danger",
                    position: "top-center"
                });
                this.file = '';
                $("#file").val('');
            } else {
                const MAX_SIZE = 2000000;
                const MAX_MP3_SIZE = 20971520;
                let MAX_WIDTH = parseInt(this.configWidth);
                let MAX_HEIGHT = parseInt(this.configHeight);

                this.imageError = '';
                let file = this.$refs.file.files[0];
								if(this.configSlug == 'background_mp3'){
									if(file.size > MAX_MP3_SIZE){
										this.imageError = `The mp3 size (${file.size}) is too much (max is ${MAX_MP3_SIZE}).`;
                    this.$vs.notify({
                        title: "File size error",
                        text: this.imageError,
                        color: "danger",
                        position: "top-center"
                    });
                    this.file = '';
                    $("#file").val('');
                    return false;
									}
									this.file = file;
								}
                if(!file || file.type.indexOf('image/') !== 0) return;
                this.image.size = file.size;
                if(this.image.size > MAX_SIZE && this.configSlug != 'background_mp3') {
                    this.imageError = `The image size (${this.image.size}) is too much (max is ${MAX_SIZE}).`;
                    this.$vs.notify({
                        title: "File size error",
                        text: this.imageError,
                        color: "danger",
                        position: "top-center"
                    });
                    this.file = '';
                    $("#file").val('');
                    return false;
                }
								if(this.configSlug != 'background_mp3'){
									let reader = new FileReader();
									reader.readAsDataURL(file);
									reader.onload = evt => {
										let img = new Image();
										img.onload = () => {
												this.file = file;
												this.image.width = img.width;
												this.image.height = img.height;
												if(this.image.width > MAX_WIDTH) {
														this.file = '';
														$("#file").val('');
														this.imageError = `The image width (${this.image.width}) is too much (max is ${MAX_WIDTH}).`;
												}
												if(this.image.height > MAX_HEIGHT) {
														this.file = '';
														$("#file").val('');
														this.imageError = `The image height (${this.image.height}) is too much (max is ${MAX_HEIGHT}).`;
												}
												if(this.imageError != ''){
														this.$vs.notify({
																title: "File dimension error",
																text: this.imageError,
																color: "danger",
																position: "top-center"
														});
												}
										}

										img.src = evt.target.result;
									}
								}
            }
        },
    },
}
</script>
